"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "dicomano": {
    "4023c67a": [{
      "hkey": "f956a1e6",
      "slug": "dicomano",
      "name": "Dicomano",
      "primary": true,
      "skipSearch": false
    }],
    "dicomano-campagna": [{
      "hkey": "f956a1e6",
      "slug": "dicomano",
      "name": "Dicomano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f685702b": [{
      "hkey": "822619bc",
      "slug": "frascole-piandrati",
      "name": "Frascole-Piandrati",
      "primary": true,
      "skipSearch": false
    }],
    "frascole": [{
      "hkey": "822619bc",
      "slug": "frascole-piandrati",
      "name": "Frascole-Piandrati",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "65c47a29": [{
      "hkey": "f14b6156",
      "slug": "dicomano",
      "name": "Dicomano",
      "primary": true,
      "skipSearch": false
    }],
    "orticaia": [{
      "hkey": "f14b6156",
      "slug": "dicomano",
      "name": "Dicomano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a0fe2440": [{
      "hkey": "f14b6156",
      "slug": "dicomano",
      "name": "Dicomano",
      "primary": true,
      "skipSearch": false
    }],
    "santa-lucia": [{
      "hkey": "f14b6156",
      "slug": "dicomano",
      "name": "Dicomano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "72570874": [{
      "hkey": "f14b6156",
      "slug": "dicomano",
      "name": "Dicomano",
      "primary": true,
      "skipSearch": false
    }],
    "vicolagna": [{
      "hkey": "f14b6156",
      "slug": "dicomano",
      "name": "Dicomano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "63cfa30b": [{
      "hkey": "f14b6156",
      "slug": "dicomano",
      "name": "Dicomano",
      "primary": true,
      "skipSearch": false
    }],
    "vicorati": [{
      "hkey": "f14b6156",
      "slug": "dicomano",
      "name": "Dicomano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3b4c2485": [{
      "hkey": "f14b6156",
      "slug": "dicomano",
      "name": "Dicomano",
      "primary": true,
      "skipSearch": false
    }],
    "villa": [{
      "hkey": "f14b6156",
      "slug": "dicomano",
      "name": "Dicomano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;